import Conversiones from "../../../utils/conversiones";
import { columns } from "../../../dtos/columns";
import { RespuestaDividendosImpagosDTO } from "../models/dividendosImpagos";

interface IProps {
  controlTabla: any;
}

export function useColumnsDividendosImpagos({ controlTabla }: IProps) {
  const COLUMNS: columns<RespuestaDividendosImpagosDTO>[] = [
    {
        name: "N° Dividendo",
        selector: (row: RespuestaDividendosImpagosDTO) => row.numeroDividendo.toString() || 'Desconocido',
        sortable: true,
        sortField: "numeroDividendo",
        wrap: true,
        export: true,
      },
      {
        name: "Estado",
        selector: (row: RespuestaDividendosImpagosDTO) => row.estadoCal || 'Desconocido',
        sortable: true,
        sortField: "estadoCal",
        wrap: true,
        export: true,
      },
      {
        name: "Fecha Vencimiento",
        selector: (row: RespuestaDividendosImpagosDTO) =>
          row.fechaVencimiento ? Conversiones.fechaCortaFormat(row.fechaVencimiento) : 'Desconocido',
        sortable: true,
        sortField: "fechaVencimiento",
        wrap: true,
        export: true,
      },
      {
        name: "Amortización (Moneda Origen)",
        selector: (row: RespuestaDividendosImpagosDTO) => row.amortizacionDividendo,
        cell: (row: RespuestaDividendosImpagosDTO) => row.amortizacionDividendo.toFixed(4),
        sortable: true,
        sortField: "amortizacionDividendo",
        wrap: true,
        export: true,
      },
      {
        name: "Intereses (Moneda Origen)",
        selector: (row: RespuestaDividendosImpagosDTO) => row.interesDividendo,
        cell: (row: RespuestaDividendosImpagosDTO) => row.interesDividendo.toFixed(4),
        sortable: true,
        sortField: "interesDividendo",
        wrap: true,
        export: true,
      },
      {
        name: "Seguro de Incendio (Moneda Origen)",
        selector: (row: RespuestaDividendosImpagosDTO) => row.seguroIncendio,
        cell: (row: RespuestaDividendosImpagosDTO) => row.seguroIncendio.toFixed(4),
        sortable: true,
        sortField: "seguroIncendio",
        wrap: true,
        export: true,
      },
      {
        name: "Seguro de Desgravamen (Moneda Origen)",
        selector: (row: RespuestaDividendosImpagosDTO) => row.seguroDesgravamen,
        cell: (row: RespuestaDividendosImpagosDTO) => row.seguroDesgravamen.toFixed(4),
        sortable: true,
        sortField: "seguroDesgravamen",
        wrap: true,
        export: true,
      },
      {
        name: "Seguro de Cesantía (Moneda Origen)",
        selector: (row: RespuestaDividendosImpagosDTO) => row.seguroCesantia,
        cell: (row: RespuestaDividendosImpagosDTO) => row.seguroCesantia.toFixed(4),
        sortable: true,
        sortField: "seguroCesantia",
        wrap: true,
        export: true,
      },
      {
        name: "Otros Seguros (Moneda Origen)",
        selector: (row: RespuestaDividendosImpagosDTO) => row.otrosSeguros,
        cell: (row: RespuestaDividendosImpagosDTO) => row.otrosSeguros.toFixed(4),
        sortable: true,
        sortField: "otrosSeguros",
        wrap: true,
        export: true,
      },
      {
        name: "Home life (Moneda Origen)",
        selector: (row: RespuestaDividendosImpagosDTO) => row.homeLife,
        cell: (row: RespuestaDividendosImpagosDTO) => row.homeLife.toFixed(4),
        sortable: true,
        sortField: "homeLife",
        wrap: true,
        export: true,
      },
      {
        name: "Total Dividendo (Moneda Origen)",
        selector: (row: RespuestaDividendosImpagosDTO) => row.totalMonedaOrigen,
        cell: (row: RespuestaDividendosImpagosDTO) =>row.totalMonedaOrigen.toFixed(4),
        sortable: true,
        sortField: "totalMonedaOrigen",
        wrap: true,
        export: true,
      },
  ]

  return { COLUMNS };
}